import { updateSubNavigationLinks } from '../Actions/FacetedSearch.action';
import {
  FACETED_SEARCH_RECEIVE,
  FACETED_SEARCH_TOGGLE_VALUE,
  FACET_FILTERS_CHANGED,
  FACETED_SEARCH_TOGGLE_COMPACT,
} from '../constants';

const defaultState = {
  subNavigation: null,
  sortCriteria: null,
  facetFilters: [],
  visibleDropdownMenu: [],
  navigationTheme: 'filter',
  productsViewCachedId: null,
  isLoading: false,
  popularFilters: null,
};

export const facetedSearch = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FACETED_SEARCH_RECEIVE:
      const newState = {
        ...state,
        ...payload,
      };
      updateSubNavigationLinks(newState);
      return newState;
    case FACET_FILTERS_CHANGED:
    case FACETED_SEARCH_TOGGLE_VALUE:
      return {
        ...state,
        facetFilters: payload.facetFilters,
      };
    case FACETED_SEARCH_TOGGLE_COMPACT: {
      const { visibleDropdownMenu } = payload;
      return {
        ...state,
        visibleDropdownMenu: state.visibleDropdownMenu.includes(
          visibleDropdownMenu
        )
          ? []
          : [visibleDropdownMenu],
      };
    }
    default:
      return state;
  }
};
